<template>
    <div class="fiveRi">
        <div class="fivecontent">
            <div class="fione_top">
                <div></div>
                <p>官方动态</p>
            </div>
            <div class="fione_middle">我们为您的作品做好版权保护，缩减繁琐的人力和时间成本</div>
            <div class="fione_content">
                <div class="fione_left">
                    <Tabs @on-click="selectTab">
                        <Tab-pane :label="item.name" :key="item.id" v-for="item in tabsList">
                        <ul class="list-card" v-for="(item,index) in cardLists"  @click="updateNum(item.id)">
                            <li class="list-card-left"><img :src="item.image?item.image + '?x-image-process=image/resize,m_fixed,w_140,h_102':defalutImg " :alt="item.title"></li>
                            <li class="list-card-right">
                            <p class="p16">{{item.title}}</p>
                            <p class="p14">{{item.description}}</p>
                            <p class="p12">
                                <span>{{item.createDate}}</span>
                                <!-- <span style="float:right">浏览量：{{item.hits}}</span> -->
                            </p>
                            </li>
                        </ul>
                        <div class="list-left-more">
                            <span style="cursor:pointer" @click="pushRouterList">更多</span>
                            <img src="@/assets/more-tip.png" alt='版权登记'/>
                        </div>
                        </Tab-pane>
                    </Tabs>
                </div>
                <div class="fione_right">
                    <div class="list-right-top">
                        <div class="list-title" v-if="showSpan">
                            <span style="margin-left:20px">在线疑问解答</span>
                            <span class="list-btn" @click="handleSapn">检索</span>
                        </div>
                        <div v-else style="width:424px;height:62px;border-bottom:1px solid #eee;overflow:hidden">
                        <div class="list-search">
                            <input v-model="questionVal" placeholder="请输入您想了解的问题" class="select-input" />
                            <span class="btn-span" @click="askQuestion">检索</span>
                        </div>
                        </div>        
                        <ul class="list-right-ul">
                            <li v-for="(item,index) in messageList" :key="index" style="cursor:pointer" @click="contentInfoModel(item.id,item.content)">
                                <span>{{item.content}}</span>
                                <span class="span_date">{{item.createDate}}</span>
                            </li>
                        </ul>
                        <div class="list-right-more">
                            <span style="cursor:pointer" @click="pushRouter">更多</span>
                            <img src="@/assets/more-tip.png" alt='版权登记'/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 问题详情 -->
        <generalframe @fatherMethod="fatherMethod" mywidth='631' myheight='420' :maintitle="maintitle" v-show="showDialog" :tishihide='false' ref="mychild">
            <div style="text-align:left;padding:20px;color:#333;height: 320px;overflow-y: auto;">{{reContent}}</div>
        </generalframe>
    </div>
</template>

<script>
    import { _getColumn,_getValidByPage,_updatePageviews,_getValidPage } from "@/api/consultation";
    import generalframe from '../../../vip/lawcomponent/generalframe.vue';
    export default {
        name:'firfive',
        components:{
            generalframe
        },
        data(){
            return {
                tabsList:[],
                pageNumber:1,
                pageSize:2,
                sort:"",
                order:"desc",
                categoryId:"",
                title:"",
                cardLists:[],
                messageList:[],
                questionVal:"",
                showSpan:true,
                content:"",
                showDialog:!1,
                reContent:"",
                pathname:'',
                maintitle:'',
                defalutImg:require('@/assets/news1.png'),
            }
        },
        methods:{
            //获取顶部菜单   
            getColumn(pathname) {
                _getColumn().then(res => {
                    if(res.code==200){
                    const topMenu = res.result;       
                    topMenu.length>0&&topMenu.map((item)=>{
                        if(item.id==2){
                        this.tabsList = item.childs;            
                        this.categoryId=item.childs[0].id;
                        }
                    });
                    this.getValidByPage();
                    }
                });
                this.pathname = pathname
            },
            //分页查询有效文章
            getValidByPage(){
                const data ={
                    pageNumber:this.pageNumber,
                    pageSize:this.pageSize,
                    sort:"create_date",
                    order:"desc",
                    categoryId:this.categoryId,
                    title:""
                }
                _getValidByPage(data).then(res => {
                    if(res.code==200){
                    this.cardLists= res.result.records;
                    this.total = Number(res.result.total);
                    this.pages = Number(res.result.pages);
                    }
                });
            },
            //获取当前选中菜单
            selectTab(key){
                switch (key) {
                    case 0:
                        this.categoryId=this.tabsList[0].id;
                        this.getValidByPage()
                        break;
                    case 1:
                        this.categoryId=this.tabsList[1].id;
                        this.getValidByPage()
                        break;
                    case 2:
                        this.categoryId=this.tabsList[2].id;
                        this.getValidByPage()
                        break;
                    case 3:
                        this.categoryId=this.tabsList[3].id;
                        this.getValidByPage()
                        break;
                    default:
                        break;
                }
            },
           //分页查询有效留言
            getValidPage(pathname){
                const value ={
                    pageNumber:1,
                    pageSize:4,
                    sort:"create_date",
                    order:"desc",
                    registerId:"",
                    content:this.content,
                    phone:""
                }
                _getValidPage(value).then(res => {
                    if(res.code==200){
                        this.messageList = res.result.records
                    }
                });
                this.pathname = pathname
            },
            //提问
            handleSapn(){
                this.showSpan=false;     
            },
            askQuestion(){
                this.content=this.questionVal;
                this.getValidPage()
            },
            //更多
            pushRouterList(){
                this.$router.push({name:'consultationList'})
            },
            pushRouter(){
                this.$router.push({name:'searchQuestion'})
            },
            //更新浏览量
            updateNum(value){
                _updatePageviews({id:value}).then(res=>{
                    if(res.code==200){
                     console.log("浏览量+1")
                    }
                })
                let tempUrl = '/consultation-info/'+value
                window.open(tempUrl+".html",'_blank')
                // this.$router.push({path: '/consultation-info', query: {id:value }});
            },
            //问题详情
            fatherMethod() {
                this.showDialog = !1;          
            },
            contentInfoModel(val,maintitle){
                this.maintitle = maintitle;
                let tempUrl = '/online-answers/'+val
                window.open(tempUrl+".html",'_blank')
                // this.showDialog = !0;
                // this.getRequest("/cmsGuestbook/get/" + val).then(res => {
                //     this.reContent=res.result.reContent
                // });
            }
        },
        created(){
            this.getColumn();
            this.getValidPage();
        },
        mounted(){
            this.getColumn();
            this.getValidPage();
        },
        watch: {
            $route(to, from) {
                let pathname = to.path;
                this.getColumn(pathname);
                this.getValidPage(pathname);
            }
        },
    }
</script>

<style scoped lang="less">
    .fiveRi{
        height:687px;
        background:url('./../../images/first09.png') 100% 100% no-repeat;
        .fivecontent{
            width:1334px;
            margin:0 auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            .fione_top{
                padding-top:80px;
                height: 55px;
                line-height: 55px;
                display:flex;
                p{
                    height:42px;
                    font-size:30px;
                    font-weight:800;
                    color:rgba(4,4,4,1);
                    letter-spacing:3px;
                    margin-left: -93px;
                    margin-bottom:14px;
                }
                div{
                    width:55px;
                    height:55px;
                    background:linear-gradient(180deg,rgba(255,238,0,1) 0%,rgba(255,216,0,1) 100%);
                    border-radius:50%;
                }
            }
            .fione_middle{
                height:28px;
                font-size:20px;
                font-weight:400;
                color:rgba(4,4,4,1);
                line-height:28px;
                letter-spacing:2px;
                margin-top: 52px;
                margin-bottom:40px;
            }
            .fione_content{
                display:flex;
                justify-content: space-between;
                align-items:center;
                width:1334px;
                margin:0 auto;
                height:380px;
                .fione_left{
                    width:880px;
                    height:380px;
                    background:rgba(255,255,255,1);
                    box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
                    border-radius:2px;
                    /deep/ .ivu-tabs-bar{
                        border-bottom: 1px solid #eee;
                        margin-bottom:0px;
                    }
                    /deep/ .ivu-tabs-nav-container{
                        height:62px;
                        line-height: 62px;
                        font-size: 16px;
                        color:rgba(51,51,51,1);
                    }
                    /deep/ .ivu-tabs-nav .ivu-tabs-tab{
                        width: 218px;
                        text-align: center;
                        padding:0px;
                        margin-right: 0px;
                        color:rgba(153,153,153,1);
                    }
                    /deep/ .ivu-tabs-nav .ivu-tabs-tab-active{
                        color:rgba(51,51,51,1);
                    }
                    /deep/ .ivu-tabs-ink-bar{
                        background-color:transparent;
                    }
                    .list-left-more{
                        height: 52px;
                        line-height: 52px;
                        font-size:14px;
                        font-weight:400;
                        color:rgba(102,102,102,1);
                        text-align: right;
                        img{
                            width:14px;
                            height: 10px;
                            vertical-align: middle;
                            margin:0 20px 0 5px;
                            cursor: pointer;
                        }
                    }
                    .list-card{
                        overflow: hidden;
                        height: 131px;
                        border-bottom: 1px solid #EEEEEE;
                        cursor: pointer;
                        li{
                            float: left;
                            list-style: none;
                        }
                        .list-card-left img{
                            width: 140px;
                            height: 102px;
                            margin: 15px 15px 0px 20px;
                        }      
                        .list-card-right{
                            width: 645px;
                            height: 120px;
                            p{              
                                line-height:22px;
                            }
                            .p16{
                                font-size:16px;
                                font-weight:bold;
                                color:rgba(51,51,51,1);
                                overflow: hidden;
                                white-space: nowrap;
                                text-overflow: ellipsis; 
                                margin-top:34px;
                            }
                            .p14{
                                line-height: 22px;
                                font-size:14px;
                                color:rgba(102,102,102,1);
                                margin:10px 0px 0px;
                                text-overflow: -o-ellipsis-lastline;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                line-clamp: 2;
                                -webkit-box-orient: vertical;
                                cursor: pointer;
                            }
                            .p12{
                                font-size:12px;
                                color:rgba(153,153,153,1);
                            }
                        }
                    }
                }
                .fione_right{
                    width:424px;
                    height:380px;
                    background:rgba(255,255,255,1);
                    box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
                    border-radius:2px;
                    .list-right-top{
                        .list-title{
                            width:424px;
                            height:62px;
                            line-height: 62px;
                            background:rgba(255,255,255,1);
                            border-radius:2px 2px 0px 0px;
                            font-size:16px;
                            color:rgba(51,51,51,1);
                            border-bottom: 1px solid #EEEEEE;
                        }
                        .list-btn{
                            display: inline-block;
                            float: right;
                            width:60px;
                            height:40px;
                            line-height: 40px;
                            background:rgba(246,246,246,1);
                            border-radius:20px;
                            font-size:14px;
                            font-weight:400;
                            text-align: center;
                            color:rgba(102,102,102,1);
                            margin:11px 20px;
                            cursor: pointer;
                        }
                        .list-right-ul{
                            overflow: hidden;
                            li{
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                list-style: none;
                                width: 404px;
                                font-size:14px;
                                color:rgba(102,102,102,1);

                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #666666;

                                margin-left: 20px;
                                padding-top: 12px;
                                padding-bottom: 12px;
                                border-bottom: 1px solid #EEEEEE;
                                span{
                                    width:394px;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                }
                                .span_date{
                                    margin-top: 4px;
                                    font-size:12px;
                                    color:rgba(153,153,153,1);
                                }
                            }
                        }
                        .list-right-more{
                            height: 49px;
                            line-height: 49px;
                            font-size:14px;
                            font-weight:400;
                            color:rgba(102,102,102,1);
                            text-align: right;
                            img{
                                width:14px;
                                height: 10px;
                                vertical-align: middle;
                                margin:0 20px 0 5px;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }
    }
    .list-search{
        width:384px;
        height:40px;
        background:rgba(246,246,246,1);
        border-radius:20px;
        margin:11px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .select-input{
            border:0px;
            background:transparent;
            outline: none;
            width: 260px;
            height: 40px;
            margin-left:26px;
        }
        .btn-span{
            display: inline-block;
            width:68px;
            height:30px;
            background:rgba(255,216,0,1);
            border-radius:20px;
            margin-right: 5px;
            text-align: center;
            line-height: 30px;
            color:#333;
            cursor: pointer;
        }
    }
</style>